import {
  type BatchEnrollCsvResult,
  type BulkMemberCsvResult,
  OrganizationsService,
  ProgramsService,
} from "@/client"

export type OrgBulkMemberResult = BulkMemberCsvResult
export type ProgramBulkEnrollResult = BatchEnrollCsvResult

export function uploadOrgMembersCsv({
  orgId,
  file,
  previewOnly,
}: {
  orgId: string
  file: File
  previewOnly: boolean
}) {
  return OrganizationsService.batchUploadMembersFromCsv({
    orgId,
    previewOnly,
    formData: { file },
  })
}

export function uploadProgramEnrollmentsCsv({
  programId,
  file,
  previewOnly,
  createMissingUsers,
}: {
  programId: string
  file: File
  previewOnly: boolean
  createMissingUsers: boolean
}) {
  return ProgramsService.batchEnrollFromCsv({
    programId,
    previewOnly,
    createMissingUsers,
    formData: { file },
  })
}
